
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24","height":"24"}},[_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h22v22H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"stroke":"#FFF","d":"M13.634 14.926l-.148-.148.389-.353a8 8 0 1 0-.737.594l.344-.245.152.152zm.185.185l3.133 3.133-3.133-3.133zm3.133 3.133l3.095 3.094-3.095-3.094z","mask":"url(#b)"}})])])])
      }
    
      }
    